export default __webpack_public_path__ + "static/media/ic_gmx_avax.8eac58e0.svg";